export function normalizeDisplayText(value, fallback = '暂无数据') {
  if (value === null || value === undefined) return fallback
  if (typeof value !== 'string') return value

  let text = value.trim()
  if (!text) return fallback

  text = text
    .replace(/\\U([0-9a-fA-F]{4,8})/g, (_, hex) => {
      try {
        return String.fromCodePoint(Number.parseInt(hex, 16))
      } catch {
        return ''
      }
    })
    .replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) => String.fromCharCode(Number.parseInt(hex, 16)))
    .replace(/\*{2,}/g, '')
    .replace(/^#+\s*/gm, '')
    .replace(/\b-?\s*Recommendation\b/gi, '')
    .replace(/\bRecommendation\b/gi, '')
    .replace(/\b(undefined|null|NaN)\b/gi, '')
    .trim()

  return text || fallback
}

export function displayValue(value, fallback = '暂无数据') {
  const normalized = normalizeDisplayText(value, fallback)
  return normalized === '' ? fallback : normalized
}
